/**
 * 时区处理工具
 * 统一将服务器时间和业务时间转换为北京时间（东八区 UTC+8）
 */
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

// 扩展 dayjs 插件
dayjs.extend(utc)
dayjs.extend(timezone)

// 北京时区常量
export const BEIJING_TIMEZONE = 'Asia/Shanghai'

/**
 * 解析 HTTP 响应头的 date 字段（UTC 时间）并转换为北京时间
 * @param dateHeader - HTTP 响应头的 date 字段（如: "Mon, 27 Jan 2025 02:00:00 GMT"）
 * @returns 北京时间的 Dayjs 对象
 */
export function parseServerTime(dateHeader: string | undefined) {
  if (!dateHeader) {
    return getCurrentBeijingTime()
  }
  return dayjs.utc(dateHeader).tz(BEIJING_TIMEZONE)
}

/**
 * 解析业务时间字符串为北京时间
 * 假设服务端返回的业务时间字符串（如 startDateTime, endDateTime）是北京时间
 * @param dateTimeString - 时间字符串（如: "2025-01-27 18:00:00"）
 * @returns 北京时间的 Dayjs 对象
 */
export function parseBusinessTime(dateTimeString: string) {
  return dayjs.tz(dateTimeString, BEIJING_TIMEZONE)
}

/**
 * 获取当前北京时间
 * @returns 北京时间的 Dayjs 对象
 */
export function getCurrentBeijingTime() {
  return dayjs().tz(BEIJING_TIMEZONE)
}

/**
 * 比较两个时间（确保都在同一时区）
 * @param time1 - 第一个时间
 * @param time2 - 第二个时间
 * @returns time1 是否在 time2 之前
 */
export function isBeforeBeijingTime(time1: dayjs.Dayjs, time2: dayjs.Dayjs) {
  return time1.tz(BEIJING_TIMEZONE).isBefore(time2.tz(BEIJING_TIMEZONE))
}

/**
 * 计算两个时间的差值（秒）
 * @param time1 - 第一个时间
 * @param time2 - 第二个时间
 * @returns 差值（秒）
 */
export function diffInSeconds(time1: dayjs.Dayjs, time2: dayjs.Dayjs) {
  return time1.tz(BEIJING_TIMEZONE).diff(time2.tz(BEIJING_TIMEZONE), 'second')
}
